var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.supported && !_vm.subscribed)?_c('v-btn',{on:{"click":_vm.subscribe}},[_vm._v("Aktivera notifieringar")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }